import api from 'api/api.config';

// Critical Element Goals operations
export const getCriticalElementGoal = ({ userId, criticalElementId, goalId }) =>
  api.get(`/${userId}/critical-elements/${criticalElementId}/goals/${goalId}`);

export const updateCriticalElementGoal = ({
  userId,
  criticalElementId,
  goalId,
  goalData,
}) =>
  api.put(
    `/${userId}/critical-elements/${criticalElementId}/goals/${goalId}`,
    JSON.stringify(goalData)
  );

export const deleteCriticalElementGoal = ({
  userId,
  criticalElementId,
  goalId,
}) =>
  api.delete(
    `/${userId}/critical-elements/${criticalElementId}/goals/${goalId}`
  );

export const getAllCriticalElementGoals = ({
  userId,
  criticalElementId,
  year,
}) =>
  api.get(
    `/${userId}/critical-elements/${criticalElementId}/goals${
      year ? `?enteringClassYear.equals=${year}` : ''
    }`
  );

// Critical Elements operations
export const getCriticalElement = ({ userId, clientId, id }) =>
  api.get(`/${userId}/clients/${clientId}/critical-elements/${id}`);

export const updateCriticalElement = ({ userId, clientId, id, elementData }) =>
  api.put(
    `/${userId}/clients/${clientId}/critical-elements/${id}`,
    JSON.stringify(elementData)
  );

export const deleteCriticalElement = ({ userId, clientId, id }) =>
  api.delete(`/${userId}/clients/${clientId}/critical-elements/${id}`);

export const getAllCriticalElements = ({ userId, clientId, year }) =>
  api.get(
    `/${userId}/clients/${clientId}/critical-elements?${
      year ? `enteringClassYear.equals=${year}&` : ''
    }sort=createdDate,desc`
  );

export const createCriticalElement = ({ userId, clientId, elementData }) =>
  api.post(
    `/${userId}/clients/${clientId}/critical-elements`,
    JSON.stringify(elementData)
  );

export const getCriticalElementHistory = ({ userId, clientId, id }) =>
  api.get(`/${userId}/clients/${clientId}/critical-elements/${id}/revisions`);

export const generateCriticalElementSummary = ({ userId, elementData }) =>
  api.post(`/${userId}/critical-element-summary`, JSON.stringify(elementData));

export const getGoalCriticalElements = ({ userId, goalId }) =>
  api.get(`/${userId}/goals/${goalId}/critical-elements`);
